// extracted by mini-css-extract-plugin
module.exports = {"lia-content-heading":"UserListForSearchTerm_lia-content-heading__TRxJ9","lia-empty-state-description":"UserListForSearchTerm_lia-empty-state-description__KNyZz"};